import { render, staticRenderFns } from "./Actualize.vue?vue&type=template&id=481c3bff&scoped=true"
import script from "./Actualize.vue?vue&type=script&lang=js"
export * from "./Actualize.vue?vue&type=script&lang=js"
import style0 from "./Actualize.vue?vue&type=style&index=0&id=481c3bff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481c3bff",
  null
  
)

export default component.exports